module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/my-contracts/pastdueinvoices/pastdueinvoices.component.scss
// module id = ./src/app/pages/client/my-contracts/pastdueinvoices/pastdueinvoices.component.scss
// module chunks = main